import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

import type { ApproveTags } from '../../types/tags'
const { TAGS_API_URL } = CONSTANT

const approveTagsById = async (updateTags: ApproveTags): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(`${TAGS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'UPDATE_APPROVE_STATUS'
		},
		body: JSON.stringify(updateTags)
	})

	return response.json()
}

export default approveTagsById
